import { contactSchema } from "@/utils/validation/contactSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { Resolver, ValidationMode } from "react-hook-form";

export const formConfig = {
  resolver: yupResolver(contactSchema) as Resolver<IContactFields>,
  mode: "all" as keyof ValidationMode,
  defaultValues: {
    firstName: "",
    lastName: "",
    email: "",
    reason: "",
    message: "",
  },
};
